import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const BulkActionsModal = ({ selectedCount, onClose, onApply }) => {
  const [action, setAction] = useState('');
  const [value, setValue] = useState('');

  const actionOptions = [
    { value: '', label: 'Selecione uma ação' },
    { value: 'price', label: 'Editar Preço' },
    { value: 'publish', label: 'Publicar em Marketplace' },
    { value: 'delete', label: 'Excluir Produtos' }
  ];

  const marketplaceOptions = [
    { value: 'mercadolivre', label: 'Mercado Livre' },
    { value: 'shopee', label: 'Shopee' },
    { value: 'amazon', label: 'Amazon' },
    { value: 'magalu', label: 'Magazine Luiza' }
  ];

  const handleApply = () => {
    if (!action) {
      alert('Selecione uma ação');
      return;
    }

    if (action !== 'delete' && !value) {
      alert('Preencha o valor');
      return;
    }

    if (action === 'delete') {
      const confirm = window.confirm(
        `Tem certeza que deseja excluir ${selectedCount} produto(s)? Esta ação não pode ser desfeita.`
      );
      if (!confirm) return;
    }

    onApply(action, value);
  };

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 z-[190] bg-black/50 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="fixed inset-0 z-[200] overflow-hidden flex items-center justify-center p-4">
        <div className="bg-background rounded-lg shadow-brand-xl w-full max-w-md">
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-border">
            <div>
              <h2 className="text-xl font-bold text-foreground">Edição em Massa</h2>
              <p className="text-sm text-muted-foreground mt-1">
                {selectedCount} produto(s) selecionado(s)
              </p>
            </div>
            
            <button
              onClick={onClose}
              className="p-2 hover:bg-muted rounded-lg transition-smooth"
            >
              <Icon name="X" size={20} />
            </button>
          </div>

          {/* Content */}
          <div className="p-6 space-y-4">
            <Select
              label="Ação"
              options={actionOptions}
              value={action}
              onChange={setAction}
              required
            />

            {action === 'price' && (
              <Input
                label="Novo Preço (R$)"
                type="number"
                step="0.01"
                value={value}
                onChange={(e) => setValue(e?.target?.value)}
                placeholder="0.00"
                required
              />
            )}

            {action === 'publish' && (
              <Select
                label="Marketplace"
                options={marketplaceOptions}
                value={value}
                onChange={setValue}
                required
              />
            )}

            {action === 'delete' && (
              <div className="bg-destructive/10 border border-destructive/20 rounded-lg p-4">
                <div className="flex gap-3">
                  <Icon name="AlertTriangle" size={20} className="text-destructive mt-0.5" />
                  <div>
                    <p className="text-sm font-medium text-foreground">Atenção!</p>
                    <p className="text-xs text-muted-foreground mt-1">
                      Esta ação irá excluir permanentemente {selectedCount} produto(s). Esta operação não pode ser desfeita.
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Footer */}
          <div className="flex items-center justify-between p-6 border-t border-border">
            <Button
              variant="outline"
              onClick={onClose}
            >
              Cancelar
            </Button>
            
            <Button
              variant={action === 'delete' ? 'destructive' : 'default'}
              iconName={action === 'delete' ? 'Trash2' : 'Check'}
              onClick={handleApply}
            >
              Aplicar
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default BulkActionsModal;